(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["BFFI_DrawerScripts"] = factory();
	else
		root["BFFI_DrawerScripts"] = factory();
})(self, () => {
return 